import { EcoOutlined, GrainOutlined } from '@material-ui/icons'

import { ILayers } from '@/types/diagnosis'

export type InterestLayers = Extract<
  ILayers,
  'idxGreen' | 'temperature' | 'leafArea' | 'stand'
>

export type ILayersMap = {
  [K in InterestLayers]: {
    message: string
    icon: React.ReactNode
    colorMap: string[]
    measurement: string
    title: string
    helpText: string
  }
}

export const layersMap: ILayersMap = {
  idxGreen: {
    message: 'Índice de verde',
    icon: <EcoOutlined />,
    colorMap: [
      '#ffff66',
      '#e3f166',
      '#c7e366',
      '#aad466',
      '#8ec666',
      '#71b866',
      '#55aa66',
      '#389b66',
      '#1c8d66',
      '#007f66',
    ],
    measurement: '',
    title:
      'O índice de verde representa os dados relacionados aos níveis de clorofila na folha que se correlacionam à atividade fotossintética.',
    helpText:
      'Como os produtos da fotossíntese representam 95% da massa seca do cultivo, é necessário controlar a atividade fotossintética das plantas para evitar que as suas folhas caiam precocemente. Controlando este índice é possível evitar perdas indesejadas de produção.',
  },
  temperature: {
    message: 'Temperatura foliar',
    icon: <span className='material-symbols-outlined'>mode_heat_cool</span>,
    colorMap: [
      '#000003',
      '#1a0b40',
      '#4a0b6a',
      '#781c6d',
      '#a42c60',
      '#cf4446',
      '#ed6825',
      '#fb9b06',
      '#f7d13c',
      '#fcfea4',
    ],
    measurement: '°C',
    title:
      'O índice de temperatura representa os dados relacionados aos níveis térmicos das folhas que se correlacionam a diversos fatores.',
    helpText:
      'Cerca de 95% da água absorvida por uma planta é utilizadda para manter o equilíbrio térmico através da transpiração. A variação na transpiração, portanto, afeta diretamente a temperatura da planta, podendo afetar diretamente as fases de desenvolvimento e sua produção final.',
  },
  leafArea: {
    message: 'Cobertura vegetal',
    icon: <GrainOutlined />,
    colorMap: [
      '#f7fcf5',
      '#e7f5e2',
      '#ceebc7',
      '#addea7',
      '#88cd86',
      '#5cb86a',
      '#37a055',
      '#1a833e',
      '#006829',
      '#00441b',
    ],
    measurement: '%',
    title:
      'A cobertura vegetal provê reservas de água e nutrientes necessários para as plantas. Realizam a cobertura e fornecem matéria orgânica para a formação e conservação do solo.',
    helpText:
      'A cobertura vegetal do solo é decisiva para redução dos efeitos erosivos do impacto direto das gotas de chuva na superfície do solo.',
  },
  stand: {
    message: 'Estande de plantas',
    icon: <span className='material-symbols-outlined'>grass</span>,
    colorMap: [
      '#800000',
      '#ff1300',
      '#ff7a00',
      '#ffe600',
      '#aaff4d',
      '#4dffaa',
      '#00d4ff',
      '#0060ff',
      '#0000ff',
      '#000080',
    ],
    measurement: '',
    title:
      'O estande quando multiplicado pelo espaçamento entrelinhas gera como resultado o índice de plantas por metro linear. Assim, é um dos componentes que impactam na produtividade da lavoura.',
    helpText:
      'Parâmetro altamente influenciado pela operação de semeadura, pois dependendo da escolha de equipamentos e velocidade do maquinário pode ocasionar falhas de plantio, plantas duplas ou até mesmo plantas triplas.',
  },
  // lai: {
  //   message: 'Índice de área foliar',
  //   color: 'viridis',
  //   icon: ...
  // } desabilitado temporariamente
}

export const possibleLayers = Object.keys(layersMap) as InterestLayers[]
